<template>

  <div class="viewcontain">
    <div class="topInfo">
      <div>
        <van-image height="30" src="/static/img/name.png" />
      </div>
    </div>
    <img :src="LogoPath" v-show="true" width="90px"   style="position:absolute;right: -45px;top: 100px; z-index: 10;" />
    <van-tabs v-model="active" @click="onClick" animated color="#94e9ff"
      background="linear-gradient(to right,#689BE5,#0047BE )" title-inactive-color="#fff" title-active-color="#fff"
      line-width="60" line-height="4">

      <van-tab title="证书查询" name="certquery" title-style="font-size: 1rem;">
        <van-form @submit="onSubmit">
          <van-field v-model="TestNO" name="TestNO" label="证书号" placeholder="请输入证书号" clearable size="large" autofocus
            label-width="50" label-class="inputlabel" :rules="[{ required: true, }]" />
          <van-field v-model="QueryNO" name="QueryNO" label="查询码" placeholder="请输入查询码" clearable size="large"
            label-width="50" label-class="inputlabel" :rules="[{ required: true, }]" />
          <div style="margin: 16px;">
            <van-button round block type="info" native-type="submit" color="linear-gradient(to right,#5f94e1,#0a50c2 )">
              查 询</van-button>
          </div>
        </van-form>
      </van-tab>

      <van-tab title="证签查询" name="goldquery" title-style="font-size: 1rem">
        <van-form @submit="onSubmit">
          <van-field v-model="TestNO" name="TestNO" label="证签号" placeholder="请输入证签号" clearable size="large" autofocus
            label-width="50" label-class="inputlabel" :rules="[{ required: true, message: '' }]" />
          <van-field v-model="Tmp" name="Tmp" label="" :rules="[{ required: false }]" disabled />
          <div style="margin: 16px;">
            <van-button round block type="info" native-type="submit" color="linear-gradient(to right,#5f94e1,#0a50c2 )">
              查 询</van-button>
          </div>
        </van-form>
      </van-tab>

      <van-tab title="报告查询" name="reportquery" title-style="font-size: 1rem">
        <van-form @submit="onSubmit">
          <van-field v-model="TestNO" name="TestNO" label="报告号" placeholder="输入报告号" clearable size="large" autofocus
            label-width="50" label-class="inputlabel" :rules="[{ required: true, message: '' }]" />
          <van-field v-model="Tmp" name="Tmp" label="" :rules="[{ required: false }]" disabled />
          <div style="margin: 16px;">
            <van-button round block type="info" native-type="submit" color="linear-gradient(to right,#5f94e1,#0a50c2 )">
              查 询</van-button>
          </div>
        </van-form>
      </van-tab>
      
    </van-tabs>




    <van-skeleton title :row="8" v-show="NOResult" />
    <van-steps direction="vertical" :active="-1" v-show="!NOResult" style="" class="vstepcontain">
      <!-- <van-empty image="search" image-size="280" v-show="!QueryResultPicShow" description="图片未上传" /> -->
      <img :src="QueryResultPicPath" v-show="QueryResultPicShow" width="280rem" height="210rem" fit="fill"
        @error="QueryResultPicPath = '/static/img/imgerror.png'">
     
      <van-step v-for="item in QueryItems" :key="item.TestNO">
        <div class="resultContainer">
          <span class="keyName">{{ item.KeyName }}</span>
          <span>&nbsp;:&nbsp;</span>
          <span class="keyValue">{{ item.KeyValue }}</span>
        </div>
      </van-step>
    </van-steps>
    <div style="min-height:60px">&nbsp;</div>
    <div class="bottomInfo">
      <van-image width="24" height="24" src="/static/img/logo.png" />
      <div><span>检测服务热线：0371-63935194</span></div>
    </div>
    <div class="beianInfo">
      <div><a href="https://beian.miit.gov.cn/" style="font-size:1em">备案号：豫ICP备17032099号-1</a></div>
    </div>
  </div>
</template>  

<!-- 引入样式文件 -->
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/vant/2.12.48/index.css"/>
<script>
import Vue from 'vue';
import { Tab, Tabs, Form, Field, Button, Step, Steps, Image as VanImage, Skeleton, Toast, Dialog, Empty, Card } from 'vant';
Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
Vue.use(Step);
Vue.use(Steps);
Vue.use(VanImage);
Vue.use(Skeleton);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Empty);
Vue.use(Card);

import { queryCert } from "@/api/index";

export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    // [Field.name]: Field,
  },

  data() {
    return {
      active: 0,
      TestNO: '',
      QueryNO: '',
      Tmp: '',
      QueryResultPicShow: false,
      NOResult: true,
      //QueryResultPicPath: "http://47.106.241.45:8080/HNJYTC/old/2015/BA-0104000001.jpg",
      QueryResultPicPath: "",
      ActiveTabName: 'certquery', //certquery  goldquery reportquery
      QueryItems: [],
      // { KeyName: '证书号', KeyValue: 'BA-0104000001' },  
      computedPropertyString: "/static/img/logo300.png",
      LogoPath: "/static/img/logo300.png"
    };
  },
  computed: {

  },

  methods: {
    doCertQuery() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '查询中···',
      });
      this.NOResult = true;
      this.QueryItems = [];
      this.QueryResultPicPath = "";
      let that = this;
      queryCert({
        TestNO: that.TestNO,
        QueryNO: that.QueryNO,
        QueryType: that.ActiveTabName
      })
        .then((res) => {
          Toast.clear();
          console.log(res);
          if (res != null && res.data != null) {
            console.log(res.data);
            var qresult = res.data;
            if (qresult != null) {
              //success
              if (qresult.Status == 1) {
                that.QueryItems = qresult.ResultItems;
                that.NOResult = false;
                if (qresult.PicPath == null || qresult.PicPath.length == 0) {
                  this.QueryResultPicShow = false;
                  this.QueryResultPicPath = "";
                }
                else {
                  this.QueryResultPicShow = true;
                  //this.QueryResultPicPath = "http://47.106.241.45:8080/HNJYTC/" + qresult.PicPath;
                  this.QueryResultPicPath =   qresult.PicPath;
                }
              } else if (qresult.Status == -1) { //testno or queryno wrong
                //查询失败 数据有误
                this.QueryResultPicShow = false;
                this.QueryResultPicPath = "";

                let alertMsg = "";
                switch (that.ActiveTabName) {
                  case "certquery": alertMsg = "您输入的证书号或查询码有误。"; break;
                  case "goldquery": alertMsg = "您输入的证签号有误。"; break;
                  case "reportquery": alertMsg = "您输入的报告号有误。"; break;
                }

                Dialog.alert({
                  title: '查询失败',
                  message: '1.' + alertMsg + '<br />2.若核实无误，请您耐心等待，数据、图片正在更新中，一般更新时间为15-20天。由于本系统的查询量较大，有部分查询可能会出现没有相关资料的信息，此时烦请您在线留言工作人员帮你查询,本中心对证书查询系统具有最终解释权。',
                  theme: 'round-button',
                }).then(() => {
                  // on close
                });

              } else {
                that.errorToast();
              }
            } else {
              that.errorToast();
            }
          } else {
            that.errorToast();
          }
        })
        .catch(function (err) {
          Toast.clear();
          console.log(err);
          that.errorToast();
        });
    },
    onSubmit(values) {
      let that = this;
      queryCert({
        TestNO: that.TestNO,
        QueryNO: that.QueryNO,
        QueryType: that.ActiveTabName
      })
      this.doCertQuery();
      that.NOResult = true;
      console.log('submit', values);
    },
    onClick(name, title) {
      console.log("name" + name + ";title:" + title);
      if (name != this.ActiveTabName) {
        this.QueryResultPicShow = false;
        this.QueryResultPicPath = "";
        this.NOResult = true;
        this.QueryItems = [];
        this.TestNO = "";
        this.QueryNO = "";
        this.ActiveTabName = name;
      }
    },
    errorToast() {
      Toast({
        message: '查询异常',
        position: 'middle',
      });
    },
    getLogoImg() {
      return require('../../assets/img/logo.png');
    },
    // getCertErrorPic(r) {
    //   console.log(r);
    //   r.target.src = "/static/img/imgerror.png;"
    //   //this.QueryResultPicPath="/static/img/imgerror.png;"
    // },
    // replaceByDefault(e) {
    //   console.log(e)
    //   //e.target.src = "/static/img/logo.png;"; 
    //   this.QueryResultPicPath = "/static/img/logo.png;";
    //   this.$forceUpdate();
    // }

  }
};



</script>

<style   scoped>
.taaa {
  color: brown;
  font-size: 128px;
}

.vstepcontain {
  background: #efefef;
  margin: 16px;
  box-shadow: 0px 0px 10px #D0D8E5;
  border-radius: 1ex;
  padding-top: 15px;
}

.resultContainer {
  text-align: flex;
}

.resultContainer .keyName {
  font-weight: bold;
  display: inline-block;
  width: 60px;
  text-align: justify;
  text-align-last: justify;
  text-justify: distribute-all-lines;

}

.resultContainer .keyValue {
  display: inline-block;
  margin-left: 10px;
}

.viewcontain {
  height: calc(100% - 60px);
}

.bottomInfo {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ececec;
  position: fixed;
  bottom: 30px;
  width: 100%;
}

.bottomInfo>div {
  margin-left: 8px;
  font-size: 0.9em;
}

.topInfo {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to right, #689BE5, #0047BE);
  width: 100%;
}

.topInfo>div {
  width: calc(100% - 20px);
  margin: 10px 0 5px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.beianInfo {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ececec;
  position: fixed;
  bottom: 20px;
  width: 100%;
}

.beianInfo>div {
  font-size: 8px;
}

.beianInfo>div>a {
  color: #646566;
}


.van-cell {
  background-image: linear-gradient(to right, #689BE5, #0047BE);
  color: #fff !important;
  z-index: 50 !important;
}

::v-deep input.van-field__control {
  color: #fff !important;
  font-size: 1rem;
  width: 230px;
}

::v-deep .van-field--error .van-field__control {
  color: #fff !important;
   z-index: 70 !important;
}

::v-deep .van-field__clear {
  z-index: 70 !important;
}

::v-deep .van-cell::after {
  border-bottom: 0px solid #ebedf0
}

::v-deep .van-field__control::-webkit-input-placeholder {
  font-size: 0.9rem;
}
</style>
 <style >
.inputlabel {
  color: #ffffff;
  margin-left: 1.3rem; 

}
</style>
<style lang="less">
 
/deep/.van-field__value {
     caret-color: #fff; 
   } 
</style>
